var MAX_TRIALS = 25;
import lnterface from "./IsdkInterface";
import { uuid } from "./utils";
import { ccServer } from "./base";
export function websocket() {
  class socket extends ccServer {
    constructor() {
      super();
      this.socket = null;
      this.timeoutObj = null;
      this.reloginTimer = null;
      this._reconnectTimes = 0;
      this.onopen = function() {};
      this.onmessage = function(msg) {};
      this.onclose = function() {};
      this.onerror = function(e) {};
      this.getPushGroupMsg = () => {};
      this.groupInfo = () => {};
      this.getInviteNotice = () => {};
      this.getreplyInviteMsg = () => {};
      this.onReceiveApplyMsg = () => {};
      this.getApplyGroupNotice = () => {};
      this.onGroupPower = () => {};
      this.OnchangeUserStatus = () => {};
      this.getHostIdentity = () => {};
      this.groupDelMemberMsg = () => {};
      this.memberExitGroupMsg = () => {};
      this.onReceiveGroupMsg = () => {};
      this.onReceiveShareMsg = () => {};
      this.onRecPowerApplyMsg = ()=>{};
      // this.kickOut =()=>{};
      this.exitCurLoign = () => {};
      this.recollectSuccess = () => {};
      this.recollecting = () => {};
      this.recollectFailed = () => {};
      this.onReceiveNameChange = () => {};
      this.groupTeamMsg = ()=>{}
      this.groupInviteMsg = ()=>{}
      // promise池
      this.promisePool = {};
      this.lockReconnect = false;
      this.url = null;
      this.sid = null;
    }
    connect(url) {
      let _this = this;
      if (!url) {
        _this.url = this.findUrl(2);
      } else {
        _this.url = url;
      }
      window.WebSocket = window.WebSocket || window.MozWebSocket;
      if (window.webSocket) {
        console.log("Error: WebSocket is not supported .");
        return;
      }
      this.socket = new WebSocket(_this.url);
      this.socket.onopen = function() {
        _this.onopen();
      };
      this.socket.onmessage = function(msg) {
        _this.onmessage(msg);
        _this.DealGroupMessage(msg);
      };
      this.socket.onclose = err => {
        if (this.lockReconnect) return;
        this.lockReconnect = true;
        setTimeout(() => {
          console.log(this._reconnectTimes);
          if (this._reconnectTimes > MAX_TRIALS) {
            this._reconnectTimes = 0;
            this.lockReconnect = false;
            return;
          }
          if (this._reconnectTimes == 0) {
            this.recollecting();
          }
          this.recollect();
          this.lockReconnect = false;
        }, 2000);
      };
      this.socket.onerror = function(err) {
        _this.onerror();
      };
    }
    //发送数据
    send(msg) {
      if (this.socket && this.socket.readyState != 3) {
        this.socket.send(msg);
        return true;
      } else if (this.socket.readyState == 3) {
        this.clearIntelval();
        console.log(`websocket connect is close,pleace try again`);
        return;
      }
      this.error("please connect to the server first !!!");
      return false;
    }
    recollect() {
      // this._reconnectTimes++;
      if (this._reconnectTimes < MAX_TRIALS) {
        this.connect(this.url);
        this._reconnectTimes++;
        if (this.socket.readyState == 3) {
          return;
        } else {
          clearInterval(this.reloginTimer);
          this.clearIntelval();
          this.onopen = () => {
            //发送数据
            this._reconnectTimes = 0;
            this.login(this.sid);
            console.log(`sdk cc reconnect success`);
            this.recollectSuccess();
            //保持长连接，发送ping
            this.setInterval(
              `cmd:9001\r\n\r\nid:${uuid(32, 16)}\r\n\r\n`,
              30000
            );
          };
        }
      } else {
        this.recollectFailed();
        clearInterval(this.reloginTimer);
        this.clearIntelval();
      }
    }
    //登录
    login(sid) {
      this.sid = sid;
      this.socket.send(
        JSON.stringify({
          cmd: "login",
          aid: 100,
          sid: sid
        })
      );
    }
    /**邀请：invite
     * parameters：
     *    uid：（string）被邀请人的uid
     *    cid：（string）被邀请人的cid
     *    body：（object）邀请信息 about ：
     *      type 消息类型（number）
     *           = 0  //呼叫方发送邀请
     *           = 1 //呼叫未登录账号的用户，返回不在线的异常提示（暂时）
     *           =2 //当被呼叫放已在会中or此时正在受到别人邀请时，有新的被呼叫，自动挂断。返回给呼叫方***占线中
     *           =3 //被呼叫接收邀请
     *           =4 //直接挂断，返回给呼叫方“***已拒绝”
     *           =5 //被呼叫方未应答会议邀请，或者其他不明导致未呼叫通，呼叫发起方提示“***无应答”
     *           =6 //邀请方取消呼叫
     *     roomid：（string）会议房间号
     *     roomname：（string）会议室名称
     *     start：（stringm）会议名字
     *     title：（string）会议主题
     *     body：（string）携带信息
     *     roompassword：（string）会议密码
     *
     * */
    invite(uid, cid, data) {
      let msg_body = {};
      msg_body["msg_body"] = [];
      msg_body["msg_body"].push({
        node_type: 5,
        type: data.type,
        roomid: data.roomid,
        roomname: data.roomid,
        title: "会议主题",
        body: "body",
        start: JSON.parse(JSON.stringify(new Date().getTime()).substr(0, 10))
      });
      this.socket.send(
        `cmd:1101\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify({
          to: uid,
          tocid: cid,
          type: 1,
          body: JSON.stringify(msg_body)
        })}`
      );
    }
    /*发送消息给某人
     * cmd:1101
     * 服务器响应：cmd：1102设置成功
     * */
    sendMsgToUser(uid, cid, msgBody) {
      this.socket.send(
        `cmd:1101\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify({
          to: uid,
          tocid: cid,
          type: 0,
          body: JSON.stringify(msgBody)
        })}`
      );
    }
    /*创建群createroup
     * cmd:1401
     * 服务器响应：cmd：1402设置成功
     * */
    createGroup(groupInfo) {
      let groupinfo = {
        name: "名称",
        topic: "公告", //可选字段
        type: 3, //类型：1：普通群；2：系统群 3.会议组
        maxnum: 500, //群上限人数
        auth: 1 //申请入群是否需要确认
      };
      groupinfo = Object.assign(groupinfo, groupInfo);
      this.socket.send(
        `cmd:1401\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(groupinfo)}`
      );
    }
    /**邀请入群
     * gid:群id
     * cid：客户id
     * info:{}//扩展字段{roomid:'',roomName:''}
     * invitee:[{uid:uid,cid:cid}]
     * **/
    inviteGroup(inviteInfo) {
      this.socket.send(
        `cmd:1403\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(inviteInfo)}`
      );
    }
    /*被邀请者响应邀请：拒绝/同意 cmd:1405
     * gid:gid,
     * cid:cid,
     * info:{}  //扩展字段{reason:kBusy(占线中),kDeny（无应答）}
     * inviter:{"uid" : "uid","cid" : "cid"},
     * response:"agree/refuse"
     * */
    responseInivte(inviteInfo) {
      this.socket.send(
        `cmd:1405\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(inviteInfo)}`
      );
    }
    /*设置群属性:
  *  "gid" : "001",
     "cid" : "cid",
     "name" : "名称",    //可选字段
    "topic" : "公告",     //可选字段
    "type" : "1",       //可选字段
	"maxnum" :500,      //可选字段
	"auth" :1/0    //申请入群是否需要确认      //可选字段
*/
    setGroupAttr(attr) {
      this.socket.send(
        `cmd:1415\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(attr)}`
      );
    }
    /*申请入群applyJoinGroup
	  cmd:1407
		服务器响应：cmd：1408设置成功
		参数：applyInfo
		       gid：群id，
				   cid：
				   proposer：{uid:"uid",cid:"cid"}
	*/
    async applyJoinGroup(applyInfo) {
      let applyJoinGroupInfo = await this.sendMessage(1407, applyInfo);
      console.log(applyJoinGroupInfo);
      return applyJoinGroupInfo;
    }
    /*响应申请：主持人同意或者拒绝
 *   "gid" : "001",
    "cid" : "cid",
    "proposer" : {"uid" : "uid","cid" : "cid", "name" : "name"},
    "response" : "refuse" / "agree"
*/
    responseApply(applyInfo) {
      this.socket.send(
        `cmd:1409\r\ntag:1\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(
          applyInfo
        )}`
      );
    }
    /*
     * 群踢人:delGroupMember
     *        cmd:1411
     *        服务器响应: cmd：1412
     *        参数：gid:群id
     *              cid:
     *              out:[{uid:'',cid:''}]
     * */
    delGroupMember(delMemberInfo) {
      this.socket.send(
        `cmd:1411\r\ntag:1\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(
          delMemberInfo
        )}`
      );
    }
    /*退群eixtGroup
      cmd: 1413
     服务器响应: cmd：1414
*    参数：gid:''
*          cid:''
*          quitter:{'uid' : 'uid','cid: 'cid', 'name': 'name'}
* */
    eixtGroup(userInfo) {
      this.socket.send(
        `cmd:1413\r\ntag:1\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(
          userInfo
        )}`
      );
    }
    /*转移群主transferHost
     *   cmd：1421
     *   服务器响应: cmd：1422
     *   参数:
     *     gid:'',
     *     cid:'',
     *     owner:{uid:'',cid:''}
     *  */
    async transferHost(owner) {
      if (this.socket.readyState == 1) {
        return await this.sendMessage(1421, owner);
      } else {
        return this.meetFailedInfo({ type: "transferHost" });
      }
    }

    /*设置群成员信息 setGroupMemberInfo
   cmd:1431
	 参数：MemberInfo
	     gid：群id
        cid:''
		user:{uid:001,cid:U001}
       set:{type:type,value:0}  //"type": 可选值：sort/share/audio/state  //value: 对应设置的值，只能是数字 0/1
 */
    async setGroupMemberInfo(MemberInfo) {
      if (this.socket.readyState == 1) {
        return await this.sendMessage(1431, MemberInfo);
      } else {
        return this.meetFailedInfo(MemberInfo.set, 1);
      }
    }
    /**设置群权限：音频、共享、批注
  cmd：1429
	参数：GroupPowerInfo
	      gid:群id，
				cid：
				set:{type:type,value:0}  // type: 可选值：share/audio/note/speak value：0(关闭)/1(开启)
**/
    setGroupPower(GroupPowerInfo) {
      this.socket.send(
        `cmd:1429\r\ntag:1\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(
          GroupPowerInfo
        )}`
      );
    }
    /**发送消息到群
	   cmd:1301
	参数：message Object
	        gid：群id
					cid：
					type：0 文本 1复合结构
					body：消息体
	**/
    sendMessageToGroup(message) {
      this.socket.send(
        `cmd:1301\r\ntag:1\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(
          message
        )}`
      );
    }
    /**接收消息设置
     * cmd：1425
     * 参数：setinfo Object
     *          gid:群#id
     *          cid
     *          rxflag：0（接收消息提示） 1（接收消息不提示） 2（完全阻止）
     * 服务器推送
     * cmd:1426(设置成功)
     */
    setGroupMsgReceive(setinfo) {
      this.socket.send(
        `cmd:1425\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(setinfo)}`
      );
    }
    /**发送申请麦克风、共享权限*
     * cmd 1433
     * gid:群ld
     * cid:客户id
     * type:audio/share
     * info:{} //扩展字段
     * */
    sendPowerApplyInfo(applyInfo) {
      this.socket.send(
        `cmd:1433\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(applyInfo)}`
      );
    }
    /*确认消息送到*/
    confirmService(cmd) {
      this.socket.send(`cmd:${cmd}\r\nid:${uuid(32, 16)}\r\n\r\n`);
    }
    /**历史消息同步
     * type： all group user
     * session：{id:'groupid or userid'，cid：groupcid or usercid}
     * max: 本次获取条数
     * updatetime：''  //查询当前时间向前Max条数据
     * */
    historyMsgSync(historyMsgInfo) {
      this.socket.send(
        `cmd:2401\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(
          historyMsgInfo
        )}`
      );
    }
    /* 设置成员昵称 */
    setNickName(info) {
      this.socket.send(
        `cmd:1423\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(info)}`
      );
    }
    /**将群消息置成已读消息
 * msgInfo
 *   type	 协议对象类型	字符串	是	all/group/user
             all:所有消息,updatetime必须有
             group: 单个群消息
             user: 单个人消息
     session	 会话信息	对象	否	 当type为all 此字段无意义
                                         当type为群 标识群id和cid
                                         当type为个人，此处为id和cid
     updatetime	消息时间	       否	如含有此字段，则标记将此值以前的所有对应消息设置为已读  与msgids 互斥
     msgids	   消息ID列表	对象	   否	当还有此值时，将符合前置条件与本条件的所有消息设置为已读 与updatetime互斥，且在type为all时无意义

 * **/
    setAlreadyReadGroupMsg(historyMsgInfo) {
      this.socket.send(
        `cmd:1501\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(
          historyMsgInfo
        )}`
      );
    }

    /**
     * @解析服务器发过来的消息
     */
    analysis(evt) {
      let analysisInfo = JSON.parse(
        evt.data.substr(evt.data.indexOf("{"), evt.data.lastIndexOf("}"))
      );
      let analysisData = {
        requestData: analysisInfo,
        cmd: evt.data.substr(
          evt.data.indexOf(":") + 1,
          evt.data.indexOf(":") + 2
        ),
        subtype:
          evt.data.indexOf("subtype") != -1
            ? evt.data.substr(evt.data.indexOf("subtype") + 8, 1)
            : null
      };
      return analysisData;
    }
    // /**
    //  * @解析服务器发过来的点对点消息
    //  * msg.cmd: 1003 邀请消息
    //  *      9004 踢下线通知
    //  */
    // DealServerMessage(msg){
    //     var requestData = this.websocket.analysis(msg);
    //     switch (msg.cmd){
    //         case 1003:
    //             let msgInfo = {
    //                 from:requestData.requestData.from,
    //                 to:requestData.requestData.to,
    //                 type:requestData.requestData.type,
    //                 body:this.DealServerMessageBody(JSON.parse(requestData.requestData.body))
    //             };
    //             return msgInfo
    //             break;
    //         case 9004:
    //             break
    //     }
    // }
    /**
     * @发送消息到服务器：异步
     * */
    sendMessage(key, content) {
      return new Promise((resolve, reject) => {
        this.promisePool[key] = {
          content,
          resolve,
          reject
        };
        this.socket.send(
          `cmd:${key}\r\nid:${uuid(32, 16)}\r\n\r\n${JSON.stringify(content)}`
        );
      });
    }
    /**@解析服务器发过来的点对点消息
     *
     * **/
    DealGroupMessage(msg) {
      var groupInfo = this.analysis(msg);
      groupInfo.cmd = JSON.parse(groupInfo.cmd);
      switch (groupInfo.cmd) {
        /*login resolve*/
        case 1100:
          if (groupInfo.cmd == 1100 && groupInfo.requestData.status != 200) {
            this.close();
            this.exitCurLoign(groupInfo);
          }
          break;
        /*得到群消息*/
        case 1303:
          this.getPushGroupMsg(groupInfo);
          break;
        /*得到群创建结果*/
        case 4101:
          let createGroupResult = {
            cmd: groupInfo.cmd,
            groupInfo: groupInfo.requestData
          };
          this.groupInfo(createGroupResult);
          break;
        /**被邀请者收到邀请消息：下行推送和响应**/
        case 4103:
          let callInfo = {
            gid: groupInfo.requestData.gid,
            cid: groupInfo.requestData.cid,
            info: JSON.parse(groupInfo.requestData.info),
            inviter: groupInfo.requestData.inviter,
            invitee: groupInfo.requestData.invitee,
            cancel: groupInfo.cancel
          };
          this.getInviteNotice(callInfo);
          break;
        /**邀请者收到被邀请者回复邀请消息/同意或者拒绝
         *	拒绝通知邀请方-下行推送和响应
         * 	同意通知所有群成员-下行推送和响应
         * **/
        case 4105:
          let InviteInfo = {
            gid: groupInfo.requestData.gid,
            cid: groupInfo.requestData.cid,
            info: groupInfo.requestData.info
              ? JSON.parse(groupInfo.requestData.info)
              : null,
            inviter: groupInfo.requestData.inviter,
            invitee: groupInfo.requestData.invitee,
            response: groupInfo.requestData.response
          };
          this.getreplyInviteMsg(InviteInfo);
          break;
        /**群主和管理员收到申请消息
         * **/
        case 4107:
          this.onReceiveApplyMsg(groupInfo.requestData);
          break;
        /*同意入群：通知所有群成员-下行推送和响应*/
        /*拒绝入群：发消息到申请者-下行推送和响应(抄送其他管理员)*/
        /*"response" : "agree/reject"*/
        case 4109:
          this.getApplyGroupNotice(groupInfo.requestData);
          break;
        /*群踢人的消息：通知所有-下行推送和响应(推送多人)*/
        case 4111:
          this.groupDelMemberMsg(groupInfo.requestData);
          break;
        /**退群：通知所有-下行推送和响应(推送多人)**/
        case 4113:
          this.memberExitGroupMsg(groupInfo.requestData);
          break;
        /**获取主持人身份**/
        case 4121:
          this.getHostIdentity(groupInfo.requestData);
          break;
        /*获得群权限*/
        case 4129:
          this.onGroupPower(groupInfo);
          break;
        /*获取设置的群成员权限*/
        case 4131:
          this.OnchangeUserStatus(groupInfo);
          break;
        /*群主和管理员收到普通用户的申请麦克风/共享权限*/
        case 4133:
          this.onRecPowerApplyMsg(groupInfo.requestData);
          this.confirmService(4134);
          break;
        /*收到主持人权限设置错误提示*/
        case 4137:
          this.onRecPowerHostErrMsg(groupInfo.requestData);
          this.confirmService(4138);
          break;
        case 4201:
          this.onReceiveGroupMsg(groupInfo.requestData);
          this.confirmService(4102);
          break;
        case 3107:
          this.onReceiveShareMsg(groupInfo.requestData);
          break;
        case 4123:
          this.onReceiveNameChange(groupInfo.requestData);
          break;
        case 3125:
          this.groupTeamMsg(groupInfo.requestData)  
          break;
        case 3127:
          this.groupInviteMsg(groupInfo.requestData)
          break;  
        case 9004:
          /*有被其他终端踢掉，登录信息变更 用户信息变更几种
              subtype 0 , info ""	 缺省的原类型,账号在其他端登入
              subtype 1 , info UserDelete 用户删除
              subtype 2 , info UserDisable	 用户禁用
              subtype 3 , info LoginDelete	 登录信息删除
              subtype 4 , info LoginModify	 登录信息修改*/
          this.close();
          this.exitCurLoign(groupInfo);
          break;
        default:
          // 收到receive收resove
          if (
            (groupInfo.cmd == 1100 && groupInfo.requestData.status == 200) ||
            groupInfo.cmd == 9002
          )
            return;
          let key = groupInfo.cmd - 1;
          const req = this.promisePool[key];
          if (!req) return;
          req.resolve(groupInfo);
          delete this.promisePool[key];
      }
    }
    //关闭socket
    close() {
      this.lockReconnect = true;
      this._reconnectTimes = 25;
      if (this.socket != undefined && this.socket != null) {
        this.socket.close();
        this.socket = null;
      }
      this.clearIntelval();
    }
    //保持长连接发送一个ping给服务器
    setInterval(msg, timer) {
      this.timer = setInterval(() => {
        this.send(msg);
      }, timer);
    }
    clearIntelval() {
      if (this.timer != null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
    uuid(len, radix) {
      var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
        ""
      );
      var uuid = [],
        i;
      radix = radix || chars.length;
      if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
      } else {
        // rfc4122, version 4 form
        var r;
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        uuid[14] = "4";
        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16);
            uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
          }
        }
      }
      return uuid.join("");
    }
  }
  return new socket();
}
